import axios from 'axios';
import {retrieveAppData, storeAppData} from '../utils/preference';
import {
   BASE_URL,
   TRAINING_LIST_BASE_URL,
   AUTHDATA,
   Attestation,
   LastAttestation,
   isProductionEnv,
} from '../utils/utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {setSignIn, setSignOut, setAttestation} from '../redux/slices/AuthSlice';
import Orientation from 'react-native-orientation-locker';
import {Platform} from 'react-native';
import {setResponseAlertData} from '../redux/slices/ResponseAlertSlice';
import logger from '../utils/logger';

//const BASE_URI = Platform.OS !== 'web' ? BASE_URL : '';

const BASE_URI =
   Platform.OS !== 'web'
      ? BASE_URL
      : process.env.NODE_ENV === 'production'
      ? BASE_URL
      : '';
const BASE_URI2 =
   Platform.OS !== 'web'
      ? TRAINING_LIST_BASE_URL
      : process.env.NODE_ENV === 'production'
      ? TRAINING_LIST_BASE_URL
      : '';
const api = axios.create({
   baseURL: BASE_URI,
});

// Create a dispatch function outside of the interceptor
let dispatch;
let isLandscape;
// Set the dispatch function using a setter function
export function setDispatch(d) {
   dispatch = d;
}
export function setLandscape(l) {
   isLandscape = l;
}
export function showTokenExpireAlertWeb(message = null, callbackType = null) {
   if (Platform.OS === 'web') {
      if (dispatch !== null && dispatch !== undefined) {
         dispatch(
            setResponseAlertData({
               showAlert: true,
               title: 'Alert!',
               message: message
                  ? message
                  : 'Your session has expired. Please login again to proceed.',
               callbackType: callbackType ? callbackType : 'TOKEN_EXPIRED',
            }),
         );
      } else {
         alert(
            message
               ? message
               : 'Your session has expired. Please refresh & login again to proceed.',
         );
      }
   }
}
export const getHeaderValueFromAsyncStorage = async () => {
   try {
      const headerValue = await AsyncStorage.getItem('TOKEN');
      return headerValue;
   } catch (error) {
      // Handle error while retrieving header value from AsyncStorage
      logger('Error retrieving header value:', error, false);
   }
};
api.interceptors.request.use(
   async config => {
      // Get the header value from AsyncStorage
      const headerValue = await getHeaderValueFromAsyncStorage(); // Set the header value in the request config
      config.headers.Token = headerValue;
      config.headers['content-type'] = 'application/x-www-form-urlencoded';
      return config;
   },
   error => {
      // Handle request error
      logger('Invalid Req: ', {error}, false);
      showTokenExpireAlertWeb(error?.message);
      logger('Request error:', error, false);
      return Promise.reject(error);
   },
);

api.interceptors.response.use(
   response => {
      if (response.config.parse) {
         //perform the manipulation here and change the response object
      }
      return response;
   },
   error => {
      if (error.response.status == 401 || error.response.status == 500) {
         let message;
         if (error.response.data instanceof ArrayBuffer) {
            message = arrayBufferToString(error.response.data);
         } else {
            message =
               error.response.status == 500
                  ? 'Internal Server Error!'
                  : error.response.data;
         }
         if (Platform.OS !== 'web') {
            if (!isLandscape) {
               Orientation.lockToPortrait();
            }
            alert(message);
         }
         //window.location.reload(true);
         //window.location.replace('/Login');
         //logoutHandler();
         showTokenExpireAlertWeb(message);
         if (Platform.OS !== 'web') {
            const user = {
               isLoggedIn: false,
               userName: '',
            };
            setTimeout(() => {
               dispatch(setSignIn(user));
            }, 1000);
         }
      }
      if (Platform.OS !== 'web') {
         return Promise.reject(error.message);
      } else {
         return;
      }
   },
);

const arrayBufferToString = data => {
   const byteArray = new Uint8Array(data);
   let byteString = '';
   for (var i = 0; i < byteArray.byteLength; i++) {
      byteString += String.fromCodePoint(byteArray[i]);
   }
   return byteString.slice(1, -1);
};
export function apiEndPoint({token}) {
   const endpoint = axios.create({
      baseURL: BASE_URI,
      maxRedirects: 0,
      redirect: false,
      headers: {
         'content-type': 'application/x-www-form-urlencoded',
      },
   });
   return endpoint;
}
export async function apiPostRequest({url, parms}) {
   logger(`URL:: ${url}`, false);
   logger(`PARAMS: ${JSON.stringify(parms)}`, false);
   logger('urlllllllllll::', url);
   const URL = manageUrlA(url);
   const response = await api
      .post(URL, parms)
      .then(res => {
         if (res) {
            const responseData = JSON.stringify(res.data);
            logger(`responseData:: ${responseData}`, false);
            return res.data;
         } else {
            return null;
         }
      })
      .catch(e => {
         logger(`API EXCEPTION ${e.message}}`, false);
         return `Oops! something went wrong.
Please check your network & try again later.`;
      });
   return response;
}
export async function apiPostService({url, parms}) {
   logger(`URL:: ${url}`, false);
   logger(`PARAMS: ${JSON.stringify(parms)}`, false);
   const URL = manageUrlA(url);
   return await api.post(URL, parms);
}
export async function apiPostRequest2({url, parms}) {
   logger(`URL:: ${url}`, false);
   logger(`PARAMS: ${JSON.stringify(parms)}`, false);
   const headerValue = await getHeaderValueFromAsyncStorage();
   // logger('API_headers::', api.defaults.headers);
   const URL = manageUrlA(url);
   const response = await api
      .post(URL, parms, {
         headers: {
            'content-type': 'application/x-www-form-urlencoded',
            Token: headerValue,
         },
         responseType: 'arraybuffer',
      })
      .then(res => {
         const responseData = JSON.stringify(res.data);
         return res.data;
      })
      .catch(e => {
         if (Platform.OS === 'web' && e.response.status == 401) {
            return e;
         }
         return 'Kindly check your network connection.';
      });
   return response;
}
export async function apiGetRequest({url, parms}) {
   const URL = manageUrlA(url);
   const response = await api
      .get(URL)
      .then(res => {
         const responseData = JSON.stringify(res.data);
         return res.data;
      })
      .catch(error => {
         if (error.response) {
            logger(JSON.stringify(error, null, 2), false);
            showTokenExpireAlertWeb(
               error.response?.status === 401 || error.response?.status === 500
                  ? error.response.data.message
                  : 'Kindly check your network connection.',
            );
            return 'Kindly check your network connection.';
         } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            logger(error.request, false);
         } else {
            // Something happened in setting up the request that triggered an Error
            logger('Error', error.message, false);
         }
      });
   return response;
}
export async function apiGetCourseList({url, onResponse, onProgressUpdate}) {
   //const URL = Platform.OS !== 'web' ? url : `Courses/${url}`;
   const URL = manageUrlB(url);

   const courseApi = axios.create({
      baseURL: BASE_URI2,
      headers: {
         'content-type': 'application/x-www-form-urlencoded',
      },
      onDownloadProgress: progressEvent => {
         const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
         );
         onProgressUpdate(percentage);
      },
   });
   retrieveAppData(url)
      .then(async data => {
         let response;
         let status;
         let errorMessage;
         if (data !== '') {
            const dataRecord = JSON.parse(data);
            onResponse(dataRecord);
         } else {
            response = await courseApi
               .get(URL)
               .then(res => {
                  const responseData = JSON.stringify(res.data);
                  status = res.status;
                  return res.data;
               })
               .catch(e => {
                  status = -1;
                  errorMessage = e.message;
               });
            if (status === 200) {
               const data = {status: true, data: response};
               storeAppData(url, JSON.stringify(data));
               onResponse(data);
            } else {
               const data = {status: false, eMessage: errorMessage};
               onResponse(data);
            }
         }
      })
      .catch(err => logger(err, false));
}
//This function is used to manage the URL based on the environment to run web on localhost
export function manageUrlA(url) {
   const URL =
      Platform.OS !== 'web'
         ? url
         : process.env.NODE_ENV === 'production'
         ? url
         : isProductionEnv
         ? `Wsvc/ws.asmx/${url}`
         : `Svc/ws.asmx/${url}`;
   logger({BASE_URI, URL}, false);
   return URL;
}
function manageUrlB(url) {
   const URL =
      Platform.OS !== 'web'
         ? url
         : process.env.NODE_ENV === 'production'
         ? url
         : `Courses/${url}`;
   logger({BASE_URI2, URL});
   return URL;
}
export function logoutHandler() {
   const user = {
      isLoggedIn: false,
      userName: '',
      authData: '',
   };
   storeAppData(AUTHDATA, JSON.stringify(user));
   dispatch(setSignOut());
   dispatch(setAttestation(false));
   storeAppData(Attestation, false);
   storeAppData(LastAttestation, null);
   storeAppData('TOKEN', null);
}
export default api;
